import React from 'react';
import NotFound from 'components/NotFound';
import Bird from 'products/nomad_insurance/assets/img/notfound/bird-spy-glass.png';

const NotFoundPage = () => {
  return (
    <NotFound
      bg="turquoise"
      linkVariant="light"
      linkTo="/nomad-insurance"
      imageSrc={Bird}
      imageAlt="Bird with spyglass illustration"
      isReversed
      imageOnBottom
    />
  );
};

export default NotFoundPage;
